import { useState } from "react";

import { Button, Modal, Table } from "react-bootstrap";

import QuestionaireSearchItemModal from "./questionnaire-search-item-modal";

type TableDataProps = {
  count: number;
  next: string;
  previous: string;
  results: {
    id: number;
    title: string;
    description: string;
    survey_title: string;
    module_title: string;
  }[];
};

export default function QuestionnaireSearchTable({ data }: { data: TableDataProps | undefined }) {
  const headers = ["LABEL", "SURVEY", "MODULE", "DESCRIPTION"];
  const [showItemModal, setShowItemModal] = useState(false);
  const [itemId, setItemId] = useState<number>();
  const [itemLabel, setItemLabel] = useState<string>();

  const handleItemClick = (itemId: number, itemLabel: string) => {
    setItemId(itemId);
    setItemLabel(itemLabel);
    setShowItemModal(true);
  };
  return (
    <>
      <Table striped responsive className="mt-4">
        <thead>
          <tr className="text-start g2-table-header-blue">
            {headers.map((item: string, index: number) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.results?.length ? (
            data.results.map((item, index) => (
              <tr key={index} className="align-middle">
                <td className="g2-link-blue fw-bold" onClick={() => handleItemClick(item.id, item.title)}>
                  {item.title}
                </td>
                <td>{item.survey_title}</td>
                <td>{item.module_title}</td>
                <td>{item.description}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={headers.length} className="text-center g2-text-grey table-striped-one">
                <span className="fst-italic">No results found</span>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <Modal show={showItemModal} onHide={() => setShowItemModal(false)} size="xl" aria-labelledby="pub-item-modal">
        <Modal.Header closeButton>
          <Modal.Title className="g2-text-grey">{itemLabel}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{itemId && <QuestionaireSearchItemModal itemId={itemId} />}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowItemModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
